<template class="">
  <section>
    <div class="">
      <div class="">
        <div class="">
          <div id="details" class="">
            <div class="d-flex flex-column">
            </div>
            <gmap-map
              :center="center"
              :zoom="18"
              map-type-id="terrain"
              style="width: 100%; height: 75vh"
            >
              <gmap-marker
                :key="'A'+index"
                v-for="(gmp, index) in locations"
                :position="gmp"
                :icon="getMarkerIcon(gmp)"
                @click="showLocByIndex(index)"
                @closeclick ="showLocByIndex(null)"
              >
                <gmap-info-window
                  :closeclick ='true'
                  @closeclick ="showLocByIndex(null)"
                  :opened="showByIndex === index"
              >
                   <div class="houseInfo">
                    <div v-if="gmp.hasOwnProperty('surveyorDetails')">
                      <div><span style="font-size:12px;font-weight:550">{{gmp.surveyorDetails.firstName + ' ' + gmp.surveyorDetails.lastName}} </span></div>
                      <div><span>{{gmp.surveyorDetails.mobile}}</span></div>
                      <div><span>{{gmp.details.updatedAt ? updatedTime(gmp.details.updatedAt) : '--'}}</span></div>
                    </div>
                     <!-- <div v-if="gmp.hasOwnProperty('driverDetails')">
                      <div><span style="font-size:12px;font-weight:550">{{gmp.driverDetails.firstName + ' '}} {{gmp.driverDetails.lastName}} </span></div>
                      <div><span>{{gmp.driverDetails.mobile}}</span></div>
                      <div v-if="gmp.vehicleDetails">
                        <div><span>{{gmp.vehicleDetails.vModelName + '(' + gmp.vehicleDetails.vNumber + ')' }}</span></div>
                      </div>
                      <div><span>{{gmp.details.updatedAt ? updatedTime(gmp.details.updatedAt): '--'}}</span></div>
                    </div> -->
                  </div> 
               </gmap-info-window>
              </gmap-marker>

              <!-- <DirectionsRenderer
                travelMode="DRIVING"
                :origin="origin"
                :destination="destionation"/> -->

            </gmap-map>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { eventBus } from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
import { MapElementFactory } from "vue2-google-maps";

export default {
  name: "locationTracking",
  data() {
    return {
      imgSrc: "https://cdn2.iconfinder.com/data/icons/IconsLandVistaMapMarkersIconsDemo/256/MapMarker_Marker_Outside_Chartreuse.png",
        center: { 
          lat: 28.7041, 
          lng: 77.1025
            },
        locations: [],
        currentLocation: null,
        showByIndex:null,
    };
  },
  mounted: function() {
        eventBus.$on("trackingLocation", (location) => {
        this.setLocationLatLng(location)
        this.center= {
          lat: location[0].lat, 
          lng: location[0].lng
            }
    });
  },

  methods: {
    setLocationLatLng: function(staffLocations) {
        navigator.geolocation.getCurrentPosition(geolocation => {
        });
        this.locations = [...staffLocations];
    },

    getMarkerIcon(staff){
      const staffType={
        surveyor:"/static/img/s_lc_1.png",
        driver: "/static/img/d_lc_1.png",
        helper: "/static/img/h_lc_1.png"
      }
      let url;
      if(staff.role == 'surveyor'){
        url = staffType.surveyor
      }
      // else if(staff.role == 'driver'){
      //   url = staffType.driver
      // } 
      // else{
      //   url = staffType.helper
      // }
      return url

    },
    
    updatedTime(date){
      return dateFormatter(date)
    },
    showLocByIndex(index){
      this.showByIndex = index
    }

  },

  beforeDestroy () {
    eventBus.$off("trackingLocation")
  }

};
</script>

<style scoped>
.houses{
  font-size: 15px;
  font-weight: 550;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// tracking.vue?6f1e8b64